module.exports = __webpack_public_path__ + "img/open-sign.5283e59d.svg";